<template>
    <!-- Layout inner -->
    <div>
      <div class="layout-inner program_guide program_guide_faq">
        <!-- Layout navbar -->
        <navbar></navbar>
        <!-- / Layout navbar -->
        <div class="layout-container">
          <div class="layout-content">
            <template v-if="showLoader">
              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <spinner size="large"></spinner>
              </div>
            </template>
            <template v-if="showPage">
              <template v-if="programGuide && programGuide.title">
                <program-guide-title :program-guide="programGuide"></program-guide-title>
              </template>

              <div class="container-fluid flex-grow-1 pg_content_container">
                <div class="row">
                  <div class="col-12">

                    <div class="pg_sec_hd" v-if="programGuide.faqGroup.label">
                      {{programGuide.faqGroup.label}}
                    </div>

                    <div v-if="programGuide.faqGroup.detail" v-html="programGuide.faqGroup.detail">
                    </div>

                    <div class="row sub_hd_bar">
                      <div class="col-12 srh_bx">
                        <input placeholder="search" aria-label="search" v-model="searchTerm" v-on:keyup.enter="searchClicked">
                        <span @click="searchClicked" class="search-icon"/>
                        <i class="fa fa-search" aria-hidden="true"></i>
                      </div>
                    </div>

                    <template v-if="filteredFAQ.length == 0">
                      <div class="list_row">
                          No results found!
                      </div>
                    </template>
                    <!-- Credential -->

                    <template v-if="programGuide.credentialList.length>0">
                      <div class="accordion_panel">
                      <div class="row accordion">
                        <div class="col-12 accordion_crd">
                            <b-card-header header-tag="header" class="row head" role="tab" block v-b-toggle="'cred'" variant="info">
                              <div class="col-1 ic_container">
                                <div class="ic ic-expand_r"></div>
                                <div class="ic ic-collapse_r"></div>
                              </div>
                              <div class="col-10 hd_txt">
                                <div>Credentials</div>
                              </div>
                            </b-card-header>

                            <b-collapse id="cred" visible role="tabpanel">
                              <b-card-body class="accordion_crd_content">
                                  <div class="self_reported_courses">
                                    <div class="list_container list_container_v4">
                                      <template v-for="(credential, j) in programGuide.credentialList">
                                          <div class="row result_row">
                                            <div class="col-12">

                                              <div class="row">
                                                <div class="col-3 thumbnail_container">
                                                  <div class="thumbnail_container_inner d-flex align-items-center">
                                                    <div class="thumbnail" v-if="credential.icon">
                                                      <img class="thumb_img" :src="credential.icon">
                                                    </div>
                                                    <span class="default_thumb" v-else>
                                                      <span class="ic ic24-credential"></span>
                                                    </span>
                                                  </div>
                                                </div>

                                                <div class="col-9 entity_details">
                                                  <div class="row">

                                                    <div class="col-12">
                                                      <div class="entity_title">
                                                        <div class="title_txt" v-html="credential.title"></div>
                                                      </div>
                                                      <div class="row">
                                                        <div class="col-12 oth_details" v-if="credential.issuer">
                                                          <span class="label">Issued by: </span>
                                                          <span class="val">{{credential.issuer}}</span>
                                                        </div>
                                                        <div class="col-12 oth_details" v-if="credential.deliveryType">
                                                          <span class="label">Delivery: </span>
                                                          <span class="val">{{credential.deliveryType}}</span>
                                                        </div>
                                                        <div class="col-12 oth_details" v-if="credential.transcript">
                                                          <span class="label">Transcript: </span>
                                                          <span class="val">{{credential.transcript}}</span>
                                                        </div>
                                                      </div>

                                                    </div>



                                                  </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12 description">
                                                <div class="" v-html="credential.description"></div>
                                              </div>
                                            </div>
                                          </div>

                                          </div>

                                      </template>
                                    </div>
                                  </div>

                              </b-card-body>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- Credential End-->

                  <template v-for="(faq, i) in filteredFAQ">
                    <template v-if="(faq.items && faq.items.length>0)">
                      <div class="accordion_panel">
                        <div class="row accordion">
                          <div class="col-12 accordion_crd">
                            <b-card-header header-tag="header" class="row head" role="tab"  block v-b-toggle="('req_'+i)" variant="info">
                              <div class="col-1 ic_container">
                                <div class="ic ic-expand_r"></div>
                                <div class="ic ic-collapse_r"></div>
                              </div>
                              <div class="col-10 hd_txt">
                                <div>{{faq.label}}</div>
                              </div>
                            </b-card-header>

                            <b-collapse :id="'req_'+i" visible role="tabpanel">
                              <b-card-body class="accordion_crd_content">

                                  <div class="row" v-if="faq.detail">
                                    <div class="col-12 p-3">
                                      <div class="description pl-3 pr-3" v-html="faq.detail"></div>
                                    </div>
                                  </div>

                                  <div class="self_reported_courses">
                                    <div class="list_container">
                                      <template v-for="(faqItem, j) in faq.items">
                                          <div class="list_row">
                                            <div class="col-12 sec_txt">
                                              <div v-html="faqItem.title"></div>
                                            </div>
                                          </div>
                                          <div class="list_row">
                                            <div class="col-12 sec_txt">
                                              <div v-html="faqItem.description"></div>
                                            </div>
                                          </div>
                                      </template>
                                    </div>
                                  </div>
                              </b-card-body>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
              </div>
            </div>
            </div>
            </template>
          </div>
        </div>
  		</div> <!-- Layout inner -->

  		<div class="loading-spinner">
  			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
  				<div class="text-center" style="color: #FFF">
  					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
  				</div>
  			</b-modal>
  		</div>

      <program-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></program-footer-navbar>

    </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import Navbar from '../../misc/components/./Navbar'
import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
export default {
  name: 'program-guide-faq',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    Navbar,
    ProgramFooterNavbar
  },
  data: () => {
    return {
      isDataLoaded: false,
      DEFAULT_TYPE: 'MAJOR',
      programGuide: {},
      showPage: false,
      searchFAQ : '',
      filteredFAQs:[],
      showLoader: true,
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults'
    }
  },

  mounted () {
    this.loadProgramGuideInfo()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers'
    ]),
    searchClicked () {
      if(!this.searchTerm){
          this.filteredFAQs = this.programGuide.faqGroup.faqGroups
      }else{
          let filtered = []
          this.programGuide.faqGroup.faqGroups.forEach((faq) => {
              let newFaq  = {'label':faq.label, 'items':[]}
              faq.items.forEach((item) => {
                  if(item.title.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 || item.description.toLowerCase().indexOf(this.searchTerm.toLowerCase())!=-1 )
                  newFaq.items.push(item)
              });
              filtered.push(newFaq)
          });
          this.filteredFAQs = filtered;
      }
    },
    async loadProgramGuideInfo () {
      this.programGuide = await this.loadProgramGuide({
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type
      })
      this.filteredFAQs = (this.programGuide.faqGroup && this.programGuide.faqGroup.faqGroups)? this.programGuide.faqGroup.faqGroups:[]
      this.showLoader = false
      this.showPage = true
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },
  computed: {
    ...mapState({
      'packages': state => state.institution.packages
    }),
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    filteredFAQ () {
      return this.filteredFAQs
    },
    noResult () {
       return this.filteredFAQs.length>0
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    returnTo () {
      if (this.isComingFromBookmark) {
        return this.$route.query.returnTo || 'bookmarks'
      }
      return this.$route.query.returnTo || 'programGuideMenu'
    },
    pageTitle () {
      if (this.isComingFromBookmark) {
        return this.$route.query.pageTitle || 'Back To Bookmarks'
      }
      return this.$route.query.pageTitle || 'Program Details'
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideFAQ.vue